import { gql } from 'graphql-tag';

export const PriceInfoFragment = gql`
  fragment PriceInfo on PriceType {
    currency
    perMonth
    referralValue
    total
  }
`;
